import {
  FETCH_REAL_POWER_FAILURE,
  FETCH_REAL_POWER_REQUEST,
  FETCH_REAL_POWER_SUCCESS,
} from './types';

const initialState = {
  loading: false,
  data: null,
  error: null,
  siteId: null,
  dateRange: null,
  receivedAt: null,
};

const realPowerVsTemperatureReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_REAL_POWER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        siteId: action.meta?.siteId,
        dateRange: action.meta?.dateRange,
      };
    case FETCH_REAL_POWER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
        siteId: action.meta?.siteId,
        dateRange: action.meta?.dateRange,
        receivedAt: action.meta?.receivedAt || Date.now(),
      };
    case FETCH_REAL_POWER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        siteId: action.meta?.siteId,
        dateRange: action.meta?.dateRange,
      };
    default:
      return state;
  }
};

export default realPowerVsTemperatureReducer;
